import { request } from '@/lib/http'

/**
 * @returns {Promise<Array>}
 */
export function fetchAll () {
  return request({
    url: 'system-module',
    method: 'get'
  })
}

export function fetchFiltered(queriesParams) {
  return request({
    url: `system-module`,
    method: 'get',
    params: queriesParams
  })
}

/**
 * @param {Number} id
 * @returns {Promise<Object>}
 */
export function show (id) {
  return request({
    url: `system-module/${id}`,
    method: 'get'
  })
}

/**
 * @param {Object} data
 * @param {String} data.name
 * @param {String} data.tag
 * @returns {Promise<Object>}
 */
export function add (data) {
  return request({
    url: 'system-module',
    method: 'post',
    data
  })
}

/**
 * @param {Number} id
 * @param {Object} data
 * @param {String} data.name
 * @param {String} data.tag
 * @returns {Promise<Object>}
 */
export function edit (id, data) {
  return request({
    url: `system-module/${id}`,
    method: 'patch',
    data
  })
}
